import { render, staticRenderFns } from "./details.vue?vue&type=template&id=56c4a702&scoped=true"
import script from "./details.vue?vue&type=script&lang=js"
export * from "./details.vue?vue&type=script&lang=js"
import style0 from "./details.vue?vue&type=style&index=0&id=56c4a702&prod&lang=css"
import style1 from "./details.vue?vue&type=style&index=1&id=56c4a702&prod&lang=scss"
import style2 from "./details.vue?vue&type=style&index=2&id=56c4a702&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c4a702",
  null
  
)

export default component.exports